import React from 'react';
import { Mail, Instagram, Facebook } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brown-900 text-cream/60 py-12 px-4" data-id="element-63">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center space-y-6" data-id="element-64">
        <div className="font-serif text-xl font-bold text-gold" data-id="element-65">
          eBookPlanet
        </div>
        <p className="font-sans text-sm tracking-widest uppercase" data-id="element-66">
          El planeta del conocimiento
        </p>

        <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8 font-sans text-sm" data-id="element-67">
          <a href="mailto:ebookplanet.support@gmail.com" className="flex items-center gap-2 hover:text-gold transition-colors" data-id="element-68">
            <Mail className="w-4 h-4" data-id="element-69" />
            ebookplanet.support@gmail.com
          </a>
          <div className="flex items-center gap-6" data-id="element-70">
            <a href="https://www.instagram.com/ebookplanet.shop/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-gold transition-colors" data-id="element-71">
              <Instagram className="w-4 h-4" data-id="element-72" />
              Instagram
            </a>
            <a href="https://www.facebook.com/profile.php?id=61590917575228" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-gold transition-colors" data-id="element-73">
              <Facebook className="w-4 h-4" data-id="element-74" />
              Facebook
            </a>
          </div>
        </div>

        <div className="w-full h-px bg-cream/10 my-4" data-id="element-75" />

        <p className="font-sans text-xs" data-id="element-76">
          © 2026 eBookPlanet — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}